__turbopack_context__.v({
  "button": "P9QCRq_button",
  "buttonAccent": "P9QCRq_buttonAccent",
  "container": "P9QCRq_container",
});
